module.exports = __webpack_public_path__ + "img/propeller-hat.35e75e3c.png";